export default __webpack_public_path__ + "static/media/social_1.a5048a09.png";